// extracted by mini-css-extract-plugin
export default {"newsArticle":"NewsArticle_newsArticle__8jvD4","date":"NewsArticle_date__d0iL1"};